

























































































import { Component, Mixins } from "vue-property-decorator";
import ProfileAssociationMixin, {
  UpdateProfileAssociationsPayload,
  UpdateProfilePayload,
} from "@/mixins/http/Agents/ProfileAssociationMixin";
import ProfileAssociation from "@/models/Agents/ProfileAssociation";
import EntryItem from "@/components/EntryItem.vue";
import { EntrySearchResult } from "@/components/EntrySearch.vue";
import { Getter } from "vuex-class";
import ClientCompanySearch from "@/components/ClientCompanySearch.vue";
import ClientCompany from "@/models/Agents/Company";
import { showToast } from "@/utils/ToastInvoker";
import ConfirmModal from "@/components/ConfirmModal.vue";
import { AdcontrolProfile } from "@/models";

const indexTag = "getProfilesAssociation";
const putTag = "putProfilesAssociation";
const ignoreTag = "ignoreProfile";

@Component({
  components: { ConfirmModal, ClientCompanySearch, EntryItem },
})
export default class ProfilesAssociationTable extends Mixins(
  ProfileAssociationMixin
) {
  @Getter("profile") profile!: AdcontrolProfile;
  profileAssociations: ProfileAssociation[] = [];
  entries: EntrySearchResult = {
    companies: [],
    brands: [],
    products: [],
    total: 0,
  };
  payload: UpdateProfilePayload[] = [];
  loading = true;

  formaDate(date: string) {
    return this.$moment(date).format("DD/MM/YYYY");
  }

  mounted() {
    this.load();
  }

  get profileSlug(): string {
    return this.profile.slug.toUpperCase();
  }

  async load() {
    this.loading = true;
    const profileAssociations = await this.getProfileAssociations(
      this.profile.slug,
      indexTag
    );
    this.profileAssociations = [...profileAssociations];
    this.loading = false;
  }

  get shownProfileAssociations() {
    return this.profileAssociations.filter((p) => !p.ignored);
  }

  async match() {
    const payload: UpdateProfileAssociationsPayload = {
      adcontrolMatches: this.payload,
    };
    try {
      this.profileAssociations = [];
      await this.updateProfileAssociations(this.profile.slug, payload, putTag);
      showToast("Associazioni salvate");
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    }
  }

  onSelected(
    matchedCompany: ClientCompany,
    profileAssociation: ProfileAssociation
  ) {
    const payload = this.payload;
    const index = payload.findIndex((p) => p.id === profileAssociation.id);
    if (index >= 0) {
      payload[index] = {
        id: profileAssociation.id,
        companyPrincipalId: matchedCompany.id,
      };
    } else {
      payload.push({
        id: profileAssociation.id,
        companyPrincipalId: matchedCompany.id,
      });
    }
    this.payload = [...payload];
  }

  onSearching(element: ProfileAssociation) {
    const payload = this.payload;
    const index = payload.findIndex((p) => p.id === element.id);
    if (index >= 0) {
      payload.splice(index, 1);
    }
    this.payload = [...payload];
  }

  async onIgnore(element: ProfileAssociation) {
    if (!element) {
      return;
    }

    const confirmed = await (
      this.$refs.ignoreConfirmModal as ConfirmModal
    ).confirm(
      `Sei sicuro di voler ignorare questa associazione? Non sarà più possibile associare questo brand con l'anagrafica ${this.profileSlug}.`
    );

    if (!confirmed) {
      return;
    }
    this.loading = true;
    try {
      await this.ignoreProfile(this.profile.slug, element.id, ignoreTag);
      showToast("Brand ignorato");
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    } finally {
      this.loading = false;
      this.load();
    }
  }

  get ignoredBrandsText(): string {
    const count = this.profileAssociations.filter((p) => p.ignored).length;
    if (count == 1) {
      return "1 brand ignorato";
    } else {
      return count > 0 ? `${count} brand ignorati` : "Nessun brand ignorato";
    }
  }

  protected async matchAssociation() {
    this.loading = true;
    try {
      await this.match();
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    } finally {
      this.loading = false;
      this.load();
    }
  }
}
